import { render, staticRenderFns } from "./LendingPage.vue?vue&type=template&id=68c82b48&scoped=true&"
import script from "./LendingPage.vue?vue&type=script&lang=ts&"
export * from "./LendingPage.vue?vue&type=script&lang=ts&"
import style0 from "./LendingPage.vue?vue&type=style&index=0&id=68c82b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c82b48",
  null
  
)

export default component.exports